export const promote = (config) => ({ ...config });
//# sourceMappingURL=hubspot-get-meeting-availability-1-to-2.js.map